var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrevArrow = function SvgPrevArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#prev-arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#78798B",
    fillRule: "evenodd",
    d: "M5.859 3.522a.437.437 0 1 1 .616.622l-1.029 1.02c-.417.413-.703.698-.897.939-.188.234-.253.385-.27.52q-.015.127 0 .254c.017.135.082.286.27.52.194.241.48.526.897.94l1.029 1.019a.437.437 0 1 1-.616.621L4.812 8.94c-.395-.391-.717-.71-.945-.995-.238-.296-.41-.597-.456-.957a2 2 0 0 1 0-.476c.046-.36.218-.661.456-.957.228-.285.55-.604.945-.995z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prev-arrow_svg__a",
    width: 19.208,
    height: 22.709,
    x: 0.396,
    y: 0.396,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_595_91"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_595_91",
    result: "shape"
  })))));
};
export { SvgPrevArrow as ReactComponent };